var _a, _b, _c, _d, _e, _f, _g, _h;
import { __decorate, __metadata } from "tslib";
import { IScope, translate } from 'angular';
import { IStateService } from 'angular-ui-router';
import { Component } from 'decorators';
import { TenantService, TenantRoles, } from 'modules/application/tenant/TenantService';
import { LoadingService } from 'modules/ui/LoadingService';
import { BlipToastService } from 'modules/shared/BlipToastService';
import template from './MoveApplicationToTenantView.html';
import BotMigrationModalView from 'modules/contact/botMigrationModal/BotMigrationModalView.html';
import BotMigrationModalContractToContractView from 'modules/contact/botMigrationModal/BotMigrationModalContractToContractView.html';
import { ContextProcessorService, Contexts } from 'modules/core/ContextProcessorService';
import { BotMigrationModalController } from 'modules/contact/botMigrationModal/BotMigrationModalController';
import RouterMigrationModalView from 'modules/contact/routerMigrationModal/RouterMigrationModalView.html';
import { RouterMigrationModalController } from 'modules/contact/routerMigrationModal/RouterMigrationModalController';
import PlaceholderIcon from 'assets/img/icons/company.svg';
import './MoveApplicationToTenant.scss';
import { SegmentService } from 'modules/application/misc/SegmentService';
import { ORGANIZATION_MIGRATION_TAB_CLOSE, ORGANIZATION_MIGRATION_CONFIRM_BUTTON, } from 'modules/application/tenant/TenantSegmentEvents';
import { applicationListStateName } from '../index';
let MoveApplicationToTenantComponent = class MoveApplicationToTenantComponent {
    static $inject = ['TenantService', '$state', '$translate', '$scope', 'ModalService', 'LoadingService', 'BlipToastService', 'SegmentService', 'ContextProcessorService'];
    constructor(TenantService, $state, $translate, $scope, ModalService, LoadingService, BlipToastService, SegmentService, ContextProcessorService) {
        'ngInject';
        this.TenantService = TenantService;
        this.$state = $state;
        this.$translate = $translate;
        this.$scope = $scope;
        this.ModalService = ModalService;
        this.LoadingService = LoadingService;
        this.BlipToastService = BlipToastService;
        this.SegmentService = SegmentService;
        this.ContextProcessorService = ContextProcessorService;
        this.placeholderIcon = PlaceholderIcon;
        this.checkedMasterApplications = [];
        this.$scope.$watch('$ctrl.checkedApplications', (newValue, oldValue) => {
            if (newValue !== oldValue) {
                this.checkedMasterApplications = newValue.filter(application => application.template === 'master');
            }
        }, true);
    }
    async $onInit() {
        this.tenantsUsers = (await this.TenantService.tenantUsersMine()).items;
        const currentTenantId = this.TenantService.getTenantPrefixFromUrl();
        this.tenantSelectOptions = this.tenantsUsers.reduce((accumulator, tenantUser) => {
            if (tenantUser.tenant.id !== currentTenantId) {
                const tenant = tenantUser.tenant;
                const iconHtml = tenant.photoUri
                    ? `<img class='tenant-image' src='${tenant.photoUri}'/>`
                    : `<span class='icon icon-sm round bp-bg-sky flex justify-center items-center'>
                                    <span class='icon icon-s icon-tenant'></span>
                                </span>`;
                accumulator.push({
                    value: tenant.id,
                    label: tenant.name,
                    description: this.TenantService.getTenantUrl(tenant.id, false),
                    icon: iconHtml,
                    disabled: tenantUser.roleId !== TenantRoles.Admin,
                });
            }
            return accumulator;
        }, []);
    }
    async showDisabledTenantWarning(ev) {
        const tenantName = ev.optionProps.label;
        const title = await this.$translate('applicationsMigration.blockedTenantWarningTitle');
        const msg = await this.$translate('applicationsMigration.blockedTenantWarningBody', { tenantName });
        this.BlipToastService.show('warning', {
            title,
            msg,
        });
    }
    uncheckAllApplications() {
        while (this.checkedApplications.length) {
            this.checkedApplications[0].checked = false;
            this.checkedApplications.shift();
        }
    }
    close() {
        this.SegmentService.createOrganizationTrack(ORGANIZATION_MIGRATION_TAB_CLOSE, { checkedApplications: this.checkedApplications });
        this.uncheckAllApplications();
        this.closeComponent();
        this.$scope.$destroy();
    }
    async moveCheckedApplications() {
        this.SegmentService.createOrganizationTrack(ORGANIZATION_MIGRATION_CONFIRM_BUTTON, { checkedApplications: this.checkedApplications });
        const selectedTenant = this.tenantsUsers.find(tenantUser => tenantUser.tenantId === this.selectedTenantId).tenant;
        const applicationsShortNames = this.checkedApplications.map(application => application.shortName);
        const invalidMasterApplicationsIds = await this.fetchInvalidApplicationsToLinkTenant(applicationsShortNames);
        if (invalidMasterApplicationsIds.length) {
            const invalidMasterApplications = this.getInvalidMasterApplications(invalidMasterApplicationsIds);
            await this.openRouterMigrationModal(invalidMasterApplications);
        }
        else {
            await this.openBotMigrationModal(applicationsShortNames, selectedTenant);
        }
    }
    async fetchInvalidApplicationsToLinkTenant(applicationsShortNames) {
        try {
            this.LoadingService.startLoading();
            return await this.TenantService.getInvalidApplicationsToLinkTenant(applicationsShortNames, this.selectedTenantId);
        }
        catch (err) {
            console.error(err);
            const errroWhileMovingTitle = await this.$translate('applicationsMigration.errorWhileMovingTitle');
            const errorWhileMovingMsg = await this.$translate('applicationsMigration.errorWhileMovingMsg');
            this.BlipToastService.show('danger', {
                title: errroWhileMovingTitle,
                msg: errorWhileMovingMsg,
            });
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    getInvalidMasterApplications(invalidMasterApplicationsIds) {
        return this.checkedMasterApplications.filter(checkedMaster => invalidMasterApplicationsIds.includes(checkedMaster.shortName));
    }
    async openBotMigrationModal(applicationsShortNames, selectedTenant, isMovingChatbot = false, estimatedDate = undefined, tenantIdOrigin = undefined) {
        let migrationModal;
        if (this.ContextProcessorService.context === Contexts.Tenants) {
            migrationModal = await this.ModalService.showModal({
                template: BotMigrationModalContractToContractView,
                controller: BotMigrationModalController,
                controllerAs: '$ctrl',
                inputs: {
                    applicationsShortNames,
                    selectedTenant,
                    isMovingChatbot,
                    estimatedDate,
                    tenantIdOrigin,
                },
            });
        }
        else {
            migrationModal = await this.ModalService.showModal({
                template: BotMigrationModalView,
                controller: BotMigrationModalController,
                controllerAs: '$ctrl',
                inputs: {
                    applicationsShortNames,
                    selectedTenant,
                    isMovingChatbot,
                    estimatedDate,
                    tenantIdOrigin,
                },
            });
        }
        const shouldClose = await migrationModal.close;
        if (shouldClose === true) {
            this.$state.go(applicationListStateName, { isMovingChatbots: true }, { reload: true });
        }
    }
    async openRouterMigrationModal(invalidMasterApplications) {
        await this.ModalService.showModal({
            template: RouterMigrationModalView,
            controller: RouterMigrationModalController,
            controllerAs: '$ctrl',
            inputs: {
                invalidRouters: invalidMasterApplications,
            },
        });
    }
};
MoveApplicationToTenantComponent.$inject = ['TenantService', '$state', '$translate', '$scope', 'ModalService', 'LoadingService', 'BlipToastService', 'SegmentService', 'ContextProcessorService'];
MoveApplicationToTenantComponent = __decorate([
    Component({
        template,
        bindings: {
            closeComponent: '&',
            checkedApplications: '<',
        },
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof TenantService !== "undefined" && TenantService) === "function" ? _a : Object, typeof (_b = typeof IStateService !== "undefined" && IStateService) === "function" ? _b : Object, typeof (_c = typeof translate !== "undefined" && translate.ITranslateService) === "function" ? _c : Object, typeof (_d = typeof IScope !== "undefined" && IScope) === "function" ? _d : Object, Object, typeof (_e = typeof LoadingService !== "undefined" && LoadingService) === "function" ? _e : Object, typeof (_f = typeof BlipToastService !== "undefined" && BlipToastService) === "function" ? _f : Object, typeof (_g = typeof SegmentService !== "undefined" && SegmentService) === "function" ? _g : Object, typeof (_h = typeof ContextProcessorService !== "undefined" && ContextProcessorService) === "function" ? _h : Object])
], MoveApplicationToTenantComponent);
export { MoveApplicationToTenantComponent };
export const closeMoveApplicationToTenantEventName = 'closeMoveApplicationToTenant';
